import { call, put } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import Axios from "../../utils/axios";
import { loginError, getAccountDone } from "../../state/user/actions";
import { setUserId, showErrorSnackbar } from "../../utils/util";
import {
  ACCOUNT_NOT_FOUND_MESSAGE,
  CREDENTIALS_ERROR_MESSAGE
} from "../../constants";
import { ACCOUNT_BY_ACCOUNT_ID } from "../../state/user/constants";

function* loginSso({ payload }) {
  const { token, accountId, redirectToLogin } = payload;
  try {
    toastr.clean();
    yield Axios.setAuthToken(token);
    const url = ACCOUNT_BY_ACCOUNT_ID.replace(":accountId", accountId);
    const result = yield call(Axios.core.get, url);
    if (result?.data) {
      setUserId(result?.data.id);
    }
    yield put(getAccountDone(result?.data || {}));
  } catch (e) {
    redirectToLogin();
    yield Axios.setAuthToken(false);
    yield put(loginError(e));
    const resp = JSON.parse(e.request.response);
    const status = resp.statusCode;
    let errorMessage = resp.message;
    if (status === 400) {
      errorMessage = CREDENTIALS_ERROR_MESSAGE;
    } else if (status === 401) {
      errorMessage = ACCOUNT_NOT_FOUND_MESSAGE;
    }
    showErrorSnackbar(errorMessage, {
      removeOnHover: false
    });
  }
}

export default loginSso;
